import type { Insight } from './content/insights';
import { SiteFooter } from './InsightsPage';

type InsightArticlePageProps = {
  insight: Insight;
  nextInsight: Insight;
  onBack: () => void;
  onOpenArticle: (slug: string) => void;
  onAssessment: () => void;
};

export function InsightArticlePage({ insight, nextInsight, onBack, onOpenArticle, onAssessment }: InsightArticlePageProps) {
  return (
    <main className="article-page">
      <article>
        <header className="article-hero">
          <img src={insight.image} alt={insight.imageAlt} />
          <div className="article-hero-grade" aria-hidden="true" />
          <div className="article-hero-copy">
            <button type="button" onClick={onBack}>INSIGHTS / {insight.number}</button>
            <span>{insight.category} · {insight.readTime}</span>
            <h1>{insight.title}</h1>
            <p>{insight.excerpt}</p>
          </div>
        </header>

        <div className="article-body">
          {insight.sections.map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
            </section>
          ))}
          <blockquote>{insight.pullQuote}</blockquote>
          <section>
            <h2>The next move is behavioral.</h2>
            <p>Understanding the mechanism matters. Rehearsing a different response when the pressure is real matters more. That is where information becomes command.</p>
          </section>
        </div>
      </article>

      <section className="article-next">
        <span>NEXT INSIGHT / {nextInsight.number}</span>
        <h2>{nextInsight.title}</h2>
        <p>{nextInsight.excerpt}</p>
        <button className="insights-read" type="button" onClick={() => onOpenArticle(nextInsight.slug)}>READ NEXT <span aria-hidden="true">→</span></button>
      </section>

      <section className="article-assessment">
        <h2>READY TO PUT THE ENGINE BACK ON YOUR SIDE?</h2>
        <button className="site-button site-button-primary" type="button" onClick={onAssessment}>BEGIN THE PRIVATE ASSESSMENT</button>
      </section>

      <SiteFooter />
    </main>
  );
}
